import Footer from "../../components/Footer";
import END_1 from "../../assets/img/end_1.png";
import END_2 from "../../assets/img/end_1.png";
import PG_2 from "../../assets/img/pg_2.png";
import "../style.css";
import { useParams } from "react-router-dom";
import PageWiseLearnMore from "./PageWiseLearnMore";
import LearnMoreSection from "./LearnMoreSection";
import Group from "./Group";
export default function EndtoEndAppService() {
  const { id } = useParams();
  const learnMoreDataCourseFinder = {
    topHeaderSection: {
      header: "End-to-End Application Service",
      desc: "Our Premium Service guarantees a minimum of one Global university offer and offers dedicated expert assistance at every stage of your study abroad journey.",
      img: END_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header:
        "Secure a guaranteed Global university offer for the upcoming intake",
      desc: "With Global StudyIn’s Premium Application Service, you’ll benefit from dedicated support every step of the way. Our experienced counsellors assist in completing your application forms, guide you in shaping a compelling personal statement, and closely monitor your submissions",
    },
    thirdSection: {
      rightSection: {
        img: END_2,
      },
      leftSection: {
        header: "What is included?",
        desc: "Our Premium Application Service guarantees you at least one Global university offer and provides expert support and guidance throughout your study abroad journey.",
      },
      leftColumnContent: [
        {
          title: "Personal consultation",
          description:
            "Our expert counsellors will evaluate your study goals and provide personalized guidance on Global  university and course options",
        },
        {
          title: "Application completion",
          description:
            "We will create three to five complete university applications on your behalf, ensuring accuracy and quality",
        },
        {
          title: "Application support",
          description:
            "Get assistance with completing and reviewing your university application forms to ensure they’re accurate.",
        },
        {
          title: "Personal statement review",
          description:
            "Our counsellors provide guidance on how to structure and write a personal statement that captures your strengths, goals, and motivations",
        },
        {
          title: "Application tracking",
          description:
            "We will track the progress of your applications after submission, closely monitoring their progress and keeping you informed",
        },
        {
          title: "Guaranteed offer",
          description:
            "Our tried and tested application process will guarantee you at least one offer from a Global university, or you will be refunded in full",
        },
      ],
      rightColumnContent: [

      ],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
  };

  const learnMoreDataServices = {
    topHeaderSection: {
      header: "End-to-End Application Service",
      desc: "Our Premium Service guarantees a minimum of one Global university offer and offers dedicated expert assistance at every stage of your study abroad journey.",
      img: END_1,
    },
    headerSec: {
      header: "Your Complete Partner in Global Education",
      desc: "From first consultation through to graduation, we provide bespoke guidance and comprehensive support throughout your international education journey.",
    },
    secondSection: {
      img: PG_2,
      header:
        "Secure a guaranteed Global university offer for the upcoming intake",
      desc: "With Global StudyIn’s Premium Application Service, you’ll benefit from dedicated support every step of the way. Our experienced counsellors assist in completing your application forms, guide you in shaping a compelling personal statement, and closely monitor your submissions",
    },
    thirdSection: {
      rightSection: {
        img: END_2,
      },
      leftSection: {
        header: "What is included?",
        desc: "Our Premium Application Service guarantees you at least one Global university offer and provides expert support and guidance throughout your study abroad journey.",
      },
      leftColumnContent: [
        {
          title: "Personal consultation",
          description:
            "Our expert counsellors will evaluate your study goals and provide personalized guidance on Global  university and course options",
        },
        {
          title: "Application completion",
          description:
            "We will create three to five complete university applications on your behalf, ensuring accuracy and quality",
        },
        {
          title: "Application support",
          description:
            "Get assistance with completing and reviewing your university application forms to ensure they’re accurate.",
        },
        {
          title: "Personal statement review",
          description:
            "Our counsellors provide guidance on how to structure and write a personal statement that captures your strengths, goals, and motivations",
        },
        {
          title: "Application tracking",
          description:
            "We will track the progress of your applications after submission, closely monitoring their progress and keeping you informed",
        },
        {
          title: "Guaranteed offer",
          description:
            "Our tried and tested application process will guarantee you at least one offer from a Global university, or you will be refunded in full",
        },
      ],
      rightColumnContent: [],
    },
    fourthSection: {
      header: "Start your Education Journey Today",
      desc: "Ready to take the next step? Book a free consultation with our education experts and let us help you achieve your Global study goals.",
    },
    enablePaymentRedirection: true
  };

  const data = id == 1 ? learnMoreDataCourseFinder : learnMoreDataServices;

  return (
    <div className="end-to-end-app-service">
      <PageWiseLearnMore activePageId={id} learnMoreData={data} />
      <Group />
      <LearnMoreSection learnMoreData={data} />

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
